import { atom, useAtom } from 'jotai';
import { TurnaroundEntity } from '../models';

const turnaroundOriginSelectedEntities = atom<Array<TurnaroundEntity>>([]);

export const useTurnaroundOriginSelectedEntities = () => useAtom(turnaroundOriginSelectedEntities);
